import React, { useState } from "react";
import {
  Button,
  Modal,
  Dropdown,
  Form,
  Row,
  Col,
  Breadcrumb,
} from "react-bootstrap";
import { FiPlus, FiCalendar, FiUpload, FiX } from "react-icons/fi";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { RiHome6Line } from "react-icons/ri";
import { MdKeyboardArrowRight } from "react-icons/md";
import { Link } from "react-router-dom";
import AddActivityModal from "../../../components/modals/activity/AddActivityModal";
import ActivityTable from "../../../components/crm/activity/ActivityTable";

const ActivityPage = () => {
  const [show, setShow] = useState(false);
  const [showImageModal, setShowImageModal] = useState(false);
  const [date, setDate] = useState(null);
  const [time, setTime] = useState(null);
  const [image, setImage] = useState(null);

  return (
    <>
      {/* HEADER / BREADCRUMB */}
      <div style={{ padding: "15px", background: "#f8f9fa" }} className="activity-page-root">
        <div
          
          className="breadcrumb-box"
        >
          <Col md={4} sm={12}>
            <div className="my-auto mb-2">
              <h4 style={{ fontWeight: "600", marginBottom: "5px" }}>
                Activity
              </h4>

              <Breadcrumb
                style={{
                  background: "transparent",
                  padding: 0,
                  margin: 0,
                  fontSize: "14px",
                }}
              >
                <Breadcrumb.Item>
                  <Link to="/">
                    <RiHome6Line
                      className="m text-dark"
                      style={{
                        fontSize: "1.2rem", // increased icon size
                        verticalAlign: "middle",
                      }}
                    />
                  </Link>
                </Breadcrumb.Item>

                <MdKeyboardArrowRight className="mt-1 fs-5" />

                <Breadcrumb.Item
                  linkAs="span"
                  className="text-dark text-decoration-none fs-6"
                >
                  CRM
                </Breadcrumb.Item>

                <MdKeyboardArrowRight className="mt-1 fs-5" />

                <Breadcrumb.Item active>
                  <span className="text-dark fs-6">Activity List</span>
                </Breadcrumb.Item>
              </Breadcrumb>
            </div>
          </Col>

          <div className="right-actions">
            <Dropdown>
              <Dropdown.Toggle className=" text-dark border border-1 bg-white">
                <FiUpload /> Export
              </Dropdown.Toggle>

              <Dropdown.Menu align="end">
                <Dropdown.Item>Export as PDF</Dropdown.Item>
                <Dropdown.Item>Export as Excel</Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>

            <Button className="btn-orange" onClick={() => setShow(true)}>
              <FiPlus /> Add Activity
            </Button>
          </div>
        </div>

        <ActivityTable />
      </div>

      {/* ADD ACTIVITY MODAL */}
      <AddActivityModal show={show} handleClose={() => setShow(false)} />
      {/* INSERT IMAGE MODAL */}

      {/* STYLES */}
      <style>{`
        .activity-page-root {
          font-family: "Inter", sans-serif;
        }

        .activity-page-root button,
        .activity-page-root input,
        .activity-page-root select,
        .activity-page-root textarea,
        .activity-page-root optgroup {
          font-family: "Inter", sans-serif;
        }

        .breadcrumb-box {
          display:flex;
          justify-content:space-between;
          align-items:center;
          flex-wrap:wrap;
          margin-bottom:20px;
        }

        .breadcrumb-box h2 {
          font-weight:600;
        }

        .right-actions {
          display:flex;
          gap:10px;
        }

        .btn-orange {
          background:#ff6b2c;
          border:none;
          color:white;
        }
          
        .btn-orange:hover {
          background: #ff6b1a !important;
        }
        .btn-white {
          background:white;
          border:1px solid #ddd;
        }
     
        .export-button:hover {
          background: #ff6b1a !important;
        }

        .export-button {
          background: #ffffff !important;
          color: white !important;
        }
        .type-buttons button {
          margin-right:8px;
        }

        .date-input {
          position:relative;
        }

        .date-input .icon {
          position:absolute;
          right:10px;
          top:10px;
        }

        .editor-toolbar {
          display:flex;
          gap:5px;
          margin-bottom:5px;
        }

        .modal-footer-custom {
          display:flex;
          justify-content:flex-end;
          gap:10px;
          margin-top:20px;
        }
.btn-orange {
  background: #ff6b2c !important;
  border: none !important;
  color: white !important;
}

.btn-orange:hover,
.btn-orange:focus,
.btn-orange:active {
  background: #e65a1f !important; /* slightly darker orange */
  border: none !important;
  color: white !important;
  box-shadow: none !important;
}

        @media(max-width:768px){
          .right-actions{
            width:100%;
            justify-content:space-between;
            margin-top:10px;
          }
        }
      `}</style>
    </>
  );
};

export default ActivityPage;
